export class ServicioProxyTransar {
  constructor(url) {
    this.urlService = document.location.origin + '/_vti_bin/Servicios/ServicioTransar.svc/' + url;
    this.urlServiceSurveys = document.location.origin + '/_vti_bin/Servicios/ServicioTransarSurvey.svc/' + url;
    this.fetchHeader = {
      'Content-Type': 'application/json',
    };
  }

  getElements(method, params = {}) {
    return fetch(this.urlService, {
      method: method,
      headers: this.fetchHeader,
      body: JSON.stringify(params),
    }).then(function (response) {
      return response.json();
    });
    // No sé por qué lo volvían string de nuevo
    // .then(function (resultJson) {
    //   return JSON.stringify(resultJson);
    // })
    // .catch((error) => console.log(error))
  }

  //Servicio transar

  getElementsSurveys(method, params = {}) {
    return fetch(this.urlServiceSurveys, {
      method: method,
      headers: this.fetchHeader,
      body: JSON.stringify(params),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (resultJson) {
        return JSON.stringify(resultJson);
      })
      .catch((error) => console.log(error));
  }

  getDataFromService(method, params = {}) {
    return fetch(this.urlService, {
      method: method,
      headers: this.fetchHeader,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (resultJson) {
        return JSON.stringify(resultJson);
      })
      .catch((error) => console.log(error));
  }

  getDataFromServiceSurveys(method, params = {}) {
    return fetch(this.urlServiceSurveys, {
      method: method,
      headers: this.fetchHeader,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (resultJson) {
        return JSON.stringify(resultJson);
      })
      .catch((error) => console.log(error));
  }

  //End transar
}
